module.exports = __webpack_public_path__ + "img/eco_wood.aea15e34.png";